import { render, staticRenderFns } from "./social_practice.vue?vue&type=template&id=658f1b08&"
import script from "./social_practice.vue?vue&type=script&lang=js&"
export * from "./social_practice.vue?vue&type=script&lang=js&"
import style0 from "./social_practice.vue?vue&type=style&index=0&id=658f1b08&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports